"use client";

import { jsx, jsxs } from "react/jsx-runtime";
import { AutumnContext } from "./AutumnContext";
import { useEffect, useState } from "react";
const useDialog = (component) => {
  const [dialogFound, setDialogFound] = useState(false);
  const [dialogProps, setDialogProps] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  useEffect(() => {
    if (dialogProps) {
      setDialogOpen(true);
    }
  }, [dialogProps]);
  useEffect(() => {
    if (!dialogOpen) {
      setTimeout(() => {
        setDialogProps(null);
      }, 200);
    }
  }, [dialogOpen]);
  const loadDialog = async () => {
    if (component) {
      setDialogFound(true);
    } else {
      setDialogFound(false);
    }
  };
  useEffect(() => {
    loadDialog();
  }, []);
  return [dialogFound, dialogProps, setDialogProps, dialogOpen, setDialogOpen];
};
const AutumnClientProvider = ({
  children,
  encryptedCustomerId,
  customerData,
  components
}) => {
  let [customer, setCustomer] = useState(null);
  const [
    prodChangeDialogFound,
    prodChangeDialogProps,
    setProdChangeDialogProps,
    prodChangeDialogOpen,
    setProdChangeDialogOpen
  ] = useDialog(components?.productChangeDialog);
  const [
    paywallFound,
    paywallProps,
    setPaywallProps,
    paywallOpen,
    setPaywallOpen
  ] = useDialog(components?.paywallDialog);
  return /* @__PURE__ */ jsxs(
    AutumnContext.Provider,
    {
      value: {
        encryptedCustomerId,
        customerData,
        customer,
        setCustomer,
        prodChangeDialog: {
          found: prodChangeDialogFound,
          setProps: setProdChangeDialogProps,
          setOpen: setProdChangeDialogOpen
        },
        paywallDialog: {
          found: paywallFound,
          setProps: setPaywallProps,
          setOpen: setPaywallOpen
        }
      },
      children: [
        components?.productChangeDialog && /* @__PURE__ */ jsx(
          components.productChangeDialog,
          {
            open: prodChangeDialogOpen,
            setOpen: setProdChangeDialogOpen,
            ...prodChangeDialogProps
          }
        ),
        components?.paywallDialog && /* @__PURE__ */ jsx(
          components.paywallDialog,
          {
            open: paywallOpen,
            setOpen: setPaywallOpen,
            ...paywallProps
          }
        ),
        children
      ]
    }
  );
};
export {
  AutumnClientProvider
};
